// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"9e9fceca","290":"4ebc3de7","716":"3964fa29","786":"9bb8d472","931":"6dd6026d"}[chunkId] + ".chunk.js";
};